<template>
  <PreviewFrame :accent="slide.accent">
    <template #presenter>
      <div class="sp-header">
        <span class="sp-bar sp-bar--xl"></span>
        <span class="sp-bar sp-bar--md"></span>
      </div>
      <div class="sp-image">
        <div class="sp-image-content">
          <span class="sp-shape sp-shape--circle"></span>
          <span class="sp-shape sp-shape--rect"></span>
          <span class="sp-shape sp-shape--tri"></span>
        </div>
        <div class="sp-mask"></div>
        <div class="sp-timer">
          <span class="sp-timer-fill"></span>
        </div>
      </div>
    </template>

    <template #audience>
      <span class="sp-phone-q"></span>
      <div class="sp-phone-hint">
        <span class="material-symbols-rounded sp-eye">visibility</span>
        <span class="sp-bar sp-bar--md"></span>
      </div>
      <div class="sp-input">
        <span class="sp-caret"></span>
      </div>
      <button type="button" class="sp-submit" tabindex="-1">
        Guess
      </button>
    </template>
  </PreviewFrame>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import type { SlideType } from '../../data/slideTypeCatalog'
import PreviewFrame from './PreviewFrame.vue'

export default Vue.extend({
  name: 'PreviewSneakAPeek',
  components: { PreviewFrame },
  props: { slide: { type: Object as PropType<SlideType>, required: true } },
})
</script>

<style scoped lang="scss">
.sp-bar {
  display: block; height: 8px; border-radius: 999px;
  background: rgba(15, 15, 20, 0.1);
}
.sp-bar--xl { width: 70%; background: rgba(15, 15, 20, 0.2); }
.sp-bar--md { width: 40%; }

.sp-header {
  display: flex; flex-direction: column; gap: 6px;
  padding-bottom: 8px;
  border-bottom: 1px dashed color-mix(in srgb, var(--accent) 20%, transparent);
}

.sp-image {
  position: relative;
  height: 130px;
  border-radius: 10px;
  overflow: hidden;
  background: rgba(15, 15, 20, 0.04);
  border: 1px solid rgba(15, 15, 20, 0.08);
}
.sp-image-content {
  position: absolute; inset: 0;
  display: flex; align-items: center; justify-content: center; gap: 14px;
  background: color-mix(in srgb, var(--accent) 12%, white);
}
.sp-shape {
  display: block;
  background: var(--accent);
}
.sp-shape--circle {
  width: 36px; height: 36px;
  border-radius: 999px;
}
.sp-shape--rect {
  width: 44px; height: 28px;
  border-radius: 4px;
  background: color-mix(in srgb, var(--accent) 70%, black);
}
.sp-shape--tri {
  width: 0; height: 0;
  background: transparent;
  border-left: 18px solid transparent;
  border-right: 18px solid transparent;
  border-bottom: 28px solid color-mix(in srgb, var(--accent) 80%, black);
}
.sp-mask {
  position: absolute; inset: 0;
  background: rgba(15, 15, 20, 0.85);
  animation: sp-peek 4s ease-in-out infinite;
}
.sp-timer {
  position: absolute;
  bottom: 8px; left: 8px; right: 8px;
  height: 4px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.2);
  overflow: hidden;
}
.sp-timer-fill {
  display: block;
  height: 100%; width: 100%;
  background: var(--accent);
  animation: sp-timer 4s linear infinite;
}

/* phone */
.sp-phone-q {
  display: block; height: 8px; width: 70%;
  border-radius: 999px;
  background: rgba(15, 15, 20, 0.18);
  margin-bottom: 4px;
}
.sp-phone-hint {
  display: flex; align-items: center; gap: 6px;
  padding: 6px 8px;
  border-radius: 6px;
  background: color-mix(in srgb, var(--accent) 8%, white);
}
.sp-eye { font-size: 14px; color: var(--accent); }
.sp-input {
  height: 30px;
  border-radius: 6px;
  border: 1px solid rgba(15, 15, 20, 0.15);
  display: flex; align-items: center;
  padding: 0 8px;
  background: white;
}
.sp-caret {
  display: block;
  width: 1px; height: 14px;
  background: var(--accent);
  animation: sp-caret 1s steps(2) infinite;
}
.sp-submit {
  appearance: none;
  padding: 7px 10px;
  border-radius: 6px;
  background: var(--accent);
  color: white;
  border: none;
  font-family: inherit;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
}

@keyframes sp-peek {
  0%, 35%   { opacity: 1; }
  45%, 65%  { opacity: 0; }
  75%, 100% { opacity: 1; }
}
@keyframes sp-timer {
  0%   { width: 100%; }
  100% { width: 0%; }
}
@keyframes sp-caret {
  0% { opacity: 1; }
  50% { opacity: 0; }
}

@media (prefers-reduced-motion: reduce) {
  .sp-mask, .sp-timer-fill, .sp-caret { animation: none; }
  .sp-mask { opacity: 1; }
}
</style>
